import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const countApi = createApi({
  reducerPath: 'countApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + '/countTransactions',
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('user');
      const url = window.location.href;

      // Crear un objeto URLSearchParams con los parámetros de la URL
      const queryParams = new URLSearchParams(url.split('?')[1]);

      // Convertir los parámetros en un objeto
      const paramsObj = {};
      queryParams.forEach((value, key) => {
          paramsObj[key] = value;
      });

      // If we have a token set in state, let's assume that we should be passing it.
      if(paramsObj["token"]) {
        headers.set('authorization', `Bearer ${paramsObj["token"]}`);
      } else if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCountById: builder.query({
      query: (id) => `/${id}`,
    }),
    getCountTransactionsByIds: builder.query({
      query: (id) => `/count/${id}`,
    }),
    getTransactionsByClient: builder.query({
      query: (id) => `/client/${id}`,
    }),
    getCountTransactionsByClient: builder.mutation({
      query({idClient, dateStart, dateEnd, categories}) {
        return {
          url: `/count/client/${idClient}?dateStart=${dateStart}&dateEnd=${dateEnd}`,
          method: 'POST',
          body: {categories},
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCountByIdQuery,
  useGetCountTransactionsByIdsQuery,
  useGetCountTransactionsByClientMutation,
  useGetTransactionsByClientQuery,
} = countApi;
